import React, { FC } from "react";

import { EditableSection } from "@/components/EditableSection";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { SkillsSection } from "./SkillsSection";

interface IEditableSkillsSectionProps {
  record: IConsultantProfile;
  onUpdate?: (profile: IConsultantProfile) => void;
  trackClick?: (sectionName: string) => void;
}

export const EditableSkillsSection: FC<IEditableSkillsSectionProps> = ({ record, onUpdate, trackClick }) => {
  return (
    <EditableSection
      padding={["lg", false, "lg", false]}
      onEditClick={() => {
        trackClick?.("Personal Skills");
      }}>
      {editableProps => <SkillsSection record={record} editableProps={editableProps} onUpdate={onUpdate} />}
    </EditableSection>
  );
};
